import { Navigate } from "react-router-dom";

/**
 * Legacy redirect: /admin/login is now unified with /login.
 * Login.jsx detects role on success and routes admin -> /admin, customer -> /cont.
 */
export default function AdminLogin() {
  return <Navigate to="/login" replace />;
}
